
import { Link } from 'react-router-dom';
import { FileText } from 'lucide-react';
import SubscribeButton from './SubscribeButton';

interface TrialFooterProps {
  daysRemaining: number;
}

const TrialFooter = ({ daysRemaining }: TrialFooterProps) => {
  return (
    <footer className="bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-800 p-4">
      <div className="flex flex-col md:flex-row justify-between items-center social-profiles-text text-sm">
        <div className="mb-2 md:mb-0">
          Votre essai se termine dans {daysRemaining} jour{daysRemaining > 1 ? 's' : ''}
        </div>
        <div className="flex items-center space-x-4">
          <Link to="/privacy" className="flex items-center text-xs text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 transition-colors">
            <FileText className="w-3 h-3 mr-1" />
            Règles de confidentialité
          </Link>
          <SubscribeButton />
        </div>
      </div>
    </footer>
  );
};

export default TrialFooter;
